/**
 * Custom tabs plugin
 */
;(function ( $, window, document, undefined ) {

	// Create the defaults once
	var pluginName = 'dcDropDown',
		defaults = {
	};

	var b = function(func, ctx) {
		return function() { return func.apply(ctx, arguments); };
	};

	// The actual plugin constructor
	function Plugin ( element, options ) {
		this.$element = $(element);
		this.settings = $.extend( {}, defaults, options );
		this._defaults = defaults;
		this._name = pluginName;
		this.init();
	}

	// Avoid Plugin.prototype conflicts
	$.extend(Plugin.prototype, {
		init: function () {
			this.$element.on('click', b(this.toggleDropDown, this));
			var $dropdown = this.$element.parent().find(this.$element.attr('data-target'));
			var $element = this.$element;

			$dropdown.on('do-close', function() {
				$dropdown.removeClass('visible');
				var $icon = $element.find('[class^="icon-arrow"]');

				if ($icon.length) {
					$icon.removeClass('icon-arrow-up');
					$icon.addClass('icon-arrow-down');
				}
			});


			$(document).on('click', function(e) {
				var $self = $(e.target);

				if (!$self.hasClass('.dc-dropdown') && !$self.closest('.dc-dropdown').length) {
					$('.dc-dropdown').trigger('do-close');
				}
			});
		},

		toggleDropDown: function (e) {
			var $self = $(e.currentTarget);
			var $dropdown = $self.parent().find($self.attr('data-target'));
			var isVisible = $dropdown.hasClass('visible');

			if (!isVisible) {
				$('.dc-dropdown').trigger('do-close');
			}

			$dropdown[ isVisible ? 'removeClass' : 'addClass' ]('visible');

			var $icon = $self.find('[class^="icon-arrow"]');
			if ($icon.length) {
				$icon.removeClass( isVisible ? 'icon-arrow-up' : 'icon-arrow-down' );
				$icon.addClass( isVisible ? 'icon-arrow-down' : 'icon-arrow-up' );
			}

			if (!isVisible) {
				if ($dropdown.find('.scrollable').length) {
					//console.log('found scrollable');
				}

				if ($dropdown.closest('.scrollable').length) {
					//console.log('closest scrollable');
				}
			}

			return false;
		}
	});

	// A really lightweight plugin wrapper around the constructor,
	// preventing against multiple instantiations
	$.fn[ pluginName ] = function ( options ) {
		this.each(function() {
			if ( !$.data( this, 'plugin_' + pluginName ) ) {
					$.data( this, 'plugin_' + pluginName, new Plugin( this, options ) );
			}
		});

		// chain jQuery functions
		return this;
	};

})( jQuery, window, document );



// WEBPACK FOOTER //
// ./src/ui/modules/dc-ui/dc-dropdown/ui-dropdown.js